import { render, staticRenderFns } from "./ViewLossForm.vue?vue&type=template&id=1847c07d"
import script from "./ViewLossForm.vue?vue&type=script&lang=ts"
export * from "./ViewLossForm.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports